<template>
  <div>
    <a-modal v-model="visible" :footer="null">
      <a-card style="max-width: 600px" :bordered="false" size="huge" class="card">
        <div class="title">宿泊同行者の申請</div>
        <div class="form-input1">
          <div class="input-title1">同行者1</div>
          <p class="input-name-title">氏名（漢字）</p>
          <a-input :value="value" type="text" placeholder="姓" />
          <a-input :value="value" type="text" placeholder="名" />
          <p class="input-email-title">メールアドレス</p>
          <a-input
            :value="value"
            type="text"
            placeholder="one@benefit.jp"
            class="input-email"
          />
        </div>

        <div class="form-input2">
          <div class="input-title2">同行者2</div>
          <p class="input-name-title">氏名（漢字）</p>
          <a-input :value="value" type="text" placeholder="姓" />
          <a-input :value="value" type="text" placeholder="名" />
          <p class="input-email-title">メールアドレス</p>
          <a-input
            :value="value"
            type="text"
            placeholder="one@benefit.jp"
            class="input-email"
          />
        </div>
        <div class="add-introduce w-full text-right">
          宿泊同行者を追加する
          <span class="icon icon-plus-action">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </span>
        </div>

        <div class="btn-cms">
          <button class="c-btn btn-grey">
            <span class="">招待メールを送信する</span>
          </button>
        </div>
      </a-card>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
